function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
        t && (r = t);
        var _n = 0, F = function F() { };
        return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
} var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try {
        a || null == t["return"] || t["return"]();
    }
    finally {
        if (u)
            throw o;
    } } }; }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
import React from 'react';
import { constants } from '../constants';
import publication from '../../public/publication.svg';
import issuereport from '../../public/issuereport.svg';
import scheduled from '../../public/scheduled.svg';
import tellus from '../../public/tellus.svg';
import notificationicon from '../../public/Notificationicon.svg';
import inventoryIcon from '../../public/ConCON_Icons,inventory.svg';
import upgradeIcon from '../../public/upgrade.svg';
import maintenanceIcon from '../../public/Maintenance.svg';
export var NOTIFICATION_POLL_INTERVAL_MS = 30000;
// Notification title constants
export var NOTIFICATION_TITLES = {
    DATASET_PUBLISHED: 'Dataset published',
    ISSUE_REPORT: 'Issue report',
    SCHEDULED_OUTAGE: 'Scheduled outage',
    FEEDBACK: "Tell us how we're doing!",
    SURVEY_AVAILABLE: 'A survey is available for you to complete',
    UPGRADE_SCHEDULED: 'Upgrade scheduled',
    MAINTENANCE_SCHEDULED: 'Maintenance scheduled'
};
// Preload icons to prevent flickering - preload SVG images for CSS mask
var preloadIcon = function preloadIcon(src) {
    var img = new Image();
    img.src = src;
};
// Preload all icons immediately on module load
for (var _i = 0, _arr = [publication, issuereport, scheduled, tellus, notificationicon, inventoryIcon, upgradeIcon, maintenanceIcon]; _i < _arr.length; _i++) {
    var icon = _arr[_i];
    preloadIcon(icon);
}
/**
 * Returns the appropriate notification icon based on the title.
 */
export function getNotificationIcon(title, color) {
    // Determine which icon to use based on exact title matches
    var iconSrc = notificationicon;
    var iconTitle = constants.notification_title_default;
    var lowerTitle = title.toLowerCase().trim();
    if (lowerTitle.includes(NOTIFICATION_TITLES.DATASET_PUBLISHED.toLowerCase())) {
        iconSrc = publication;
        iconTitle = constants.notification_title_publication;
    }
    else if (lowerTitle.includes(NOTIFICATION_TITLES.ISSUE_REPORT.toLowerCase())) {
        iconSrc = issuereport;
        iconTitle = constants.notification_title_issue;
    }
    else if (lowerTitle.includes(NOTIFICATION_TITLES.SCHEDULED_OUTAGE.toLowerCase())) {
        iconSrc = scheduled;
        iconTitle = constants.notification_title_scheduled_outage;
    }
    else if (lowerTitle === NOTIFICATION_TITLES.FEEDBACK.toLowerCase()) {
        iconSrc = tellus;
        iconTitle = constants.notification_title_feedback;
    }
    else if (lowerTitle.includes(NOTIFICATION_TITLES.SURVEY_AVAILABLE.toLowerCase())) {
        iconSrc = inventoryIcon;
        iconTitle = constants.notification_title_survey;
    }
    else if (lowerTitle.includes(NOTIFICATION_TITLES.UPGRADE_SCHEDULED.toLowerCase())) {
        iconSrc = upgradeIcon;
        iconTitle = constants.notification_title_upgrade;
    }
    else if (lowerTitle.includes(NOTIFICATION_TITLES.MAINTENANCE_SCHEDULED.toLowerCase())) {
        iconSrc = maintenanceIcon;
        iconTitle = constants.notification_title_maintenance;
    }
    // If color is provided, use mask style with preloaded image
    if (color) {
        // Container with border
        var containerStyle = {
            width: '32px',
            height: '32px',
            border: '1px solid #D1D5DB',
            // Grey border like in the image
            borderRadius: '50%',
            padding: '4px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'transparent',
            position: 'relative'
        };
        // Mask style for the icon inside
        var maskStyle = {
            background: color,
            width: '20px',
            // Slightly smaller to fit inside the bordered container
            height: '20px',
            display: 'inline-block',
            WebkitMaskImage: "url(".concat(iconSrc, ")"),
            WebkitMaskSize: 'contain',
            WebkitMaskRepeat: 'no-repeat',
            WebkitMaskPosition: 'center',
            maskImage: "url(".concat(iconSrc, ")"),
            maskSize: 'contain',
            maskRepeat: 'no-repeat',
            maskPosition: 'center'
        };
        return /*#__PURE__*/ React.createElement("div", {
            style: containerStyle,
            title: iconTitle
        }, /*#__PURE__*/ React.createElement("div", {
            style: maskStyle
        }));
    }
    // Without color, use img tag with border container
    return /*#__PURE__*/ React.createElement("div", {
        style: {
            width: '32px',
            height: '32px',
            border: '1px solid #D1D5DB',
            // Grey border like in the image
            borderRadius: '50%',
            padding: '4px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'transparent'
        },
        title: iconTitle
    }, /*#__PURE__*/ React.createElement("img", {
        src: iconSrc,
        alt: iconTitle,
        loading: "eager",
        style: {
            width: '20px',
            // Slightly smaller to fit inside the bordered container
            height: '20px',
            display: 'block'
        }
    }));
}
/**
 * Helper function to sort notifications by time (most recent first)
 */
function sortByTimeDescending(notifications) {
    return notifications.sort(function (a, b) {
        var _a$meta, _b$meta;
        var aTime = (_a$meta = a.meta) !== null && _a$meta !== void 0 && _a$meta.created ? new Date(a.meta.created).getTime() : 0;
        var bTime = (_b$meta = b.meta) !== null && _b$meta !== void 0 && _b$meta.created ? new Date(b.meta.created).getTime() : 0;
        return bTime - aTime;
    });
}
/**
 * Groups notifications into "recent" (last 7 days, no heading), "lastWeek", "lastMonth", "threeMonthsAgo", "oneYearAgo", and "older".
 * Feedback notifications ("Tell us how we're doing!") are always placed at the top within each group.
 */
export function groupNotifications(notifications) {
    var now = new Date();
    var recent = [];
    var lastWeek = [];
    var lastMonth = [];
    var threeMonthsAgo = [];
    var oneYearAgo = [];
    var older = [];
    var startOfRecent = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
    var startOfLastWeek = new Date(now.getTime() - 14 * 24 * 60 * 60 * 1000);
    var startOfLastMonth = new Date(now.getFullYear(), now.getMonth() - 1, now.getDate());
    var startOfThreeMonthsAgo = new Date(now.getFullYear(), now.getMonth() - 3, now.getDate());
    var startOfOneYearAgo = new Date(now.getFullYear() - 1, now.getMonth(), now.getDate());
    var _iterator = _createForOfIteratorHelper(notifications), _step;
    try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _n$meta;
            var n = _step.value;
            var created = (_n$meta = n.meta) !== null && _n$meta !== void 0 && _n$meta.created ? new Date(n.meta.created) : null;
            if (!created)
                continue;
            if (created >= startOfRecent) {
                recent.push(n);
            }
            else if (created >= startOfLastWeek) {
                lastWeek.push(n);
            }
            else if (created >= startOfLastMonth) {
                lastMonth.push(n);
            }
            else if (created >= startOfThreeMonthsAgo) {
                threeMonthsAgo.push(n);
            }
            else if (created >= startOfOneYearAgo) {
                oneYearAgo.push(n);
            }
            else {
                older.push(n);
            }
        }
        // Return groups sorted by time (most recent first) - feedback prioritization is handled in the component
    }
    catch (err) {
        _iterator.e(err);
    }
    finally {
        _iterator.f();
    }
    return {
        recent: sortByTimeDescending(recent),
        lastWeek: sortByTimeDescending(lastWeek),
        lastMonth: sortByTimeDescending(lastMonth),
        threeMonthsAgo: sortByTimeDescending(threeMonthsAgo),
        oneYearAgo: sortByTimeDescending(oneYearAgo),
        older: sortByTimeDescending(older)
    };
}
/**
 * Returns a "time ago" string for a given date.
 * For dates older than 7 days, returns formatted date (e.g., "Oct 31").
 */
export function getTimeAgo(dateString) {
    if (!dateString)
        return '';
    var now = new Date();
    var date = new Date(dateString);
    var diff = (now.getTime() - date.getTime()) / 1000;
    var diffInDays = diff / 86400;
    if (diff < 60)
        return "".concat(Math.floor(diff), "s ").concat(constants.time_ago_suffix);
    if (diff < 3600)
        return "".concat(Math.floor(diff / 60), "min ").concat(constants.time_ago_suffix);
    if (diff < 86400)
        return "".concat(Math.floor(diff / 3600), "h ").concat(constants.time_ago_suffix);
    if (diffInDays < 7)
        return "".concat(Math.floor(diffInDays), "d ").concat(constants.time_ago_suffix);
    // For dates older than 7 days, show formatted date (e.g., "Oct 31")
    return date.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric'
    });
}
/**
 * Formats a date/time according to user's browser locale.
 * Returns format like "11/06/2025 11:00AM"
 */
export function formatScheduledDateTime(dateString) {
    if (!dateString)
        return '';
    var date = new Date(dateString);
    // Get user's browser locale
    var locale = navigator.language || 'en-US';
    // Format date and time together using toLocaleString
    return date.toLocaleString(locale, {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
    });
}
/**
 * Gets the formatted message for upgrade/maintenance notifications.
 * If the notification has scheduled and expires fields, formats the message
 * with the date range according to user's browser locale.
 */
export function getFormattedNotificationMessage(title, message, scheduled, expires) {
    var lowerTitle = title.toLowerCase().trim();
    // Check if this is an upgrade or maintenance notification
    var isUpgradeOrMaintenance = lowerTitle.includes(NOTIFICATION_TITLES.UPGRADE_SCHEDULED.toLowerCase()) || lowerTitle.includes(NOTIFICATION_TITLES.MAINTENANCE_SCHEDULED.toLowerCase());
    // If it's upgrade/maintenance and has scheduled/expires dates, replace placeholders in the API message
    if (isUpgradeOrMaintenance && scheduled && expires) {
        var formattedScheduled = formatScheduledDateTime(scheduled);
        var formattedExpires = formatScheduledDateTime(expires);
        var formattedMessage = message.replace('<scheduled>', formattedScheduled).replace('<expires>', formattedExpires);
        return formattedMessage;
    }
    return message;
}
